<!-- 发送弹框 -->
<template>
    <el-dialog center custom-class="innerDialog" width="30%" :show-close="false" :visible.sync="innerVisible"
        append-to-body>
        <header class="title">
            您给 法国巴黎 Mercure paris****亲，，销售部发出的直采询价如下:
        </header>
        <main class="main">
            <hotelDetail v-if="state === 0"></hotelDetail>
            <siteDetail v-if="state === 1"></siteDetail>
        </main>
        <footer class="footer">
            <div class="footerL">
                <p>提醒:</p>
                <div class="footerLLine">
                    <p>（1）</p><span>您将在24小时内收到酒店给您的回复</span>
                </div>
                <div class="footerLLine">
                    <p>（2）</p><span>请您扫描并关注右侧二维码，酒店给您报价后您将第一时间收到;</span>
                </div>
                <div class="footerLLine">
                    <p>（3）</p><span>您的会员手机号是:13912346478，是否需要补充您的第二联系号码
                        <el-input style="width: 1.2rem;" size="mini" v-model="input" placeholder="电话号码"></el-input>
                        方便我们同事联系到您。您也可以扫加右侧客服微信;
                    </span>
                </div>
                <div class="footerLLine">
                    <p>（4）</p><span>{{ radioSelectList[state].title }}
                        <el-radio-group v-model="radio">
                            <el-radio v-for="(n, m) in  radioSelectList[state].arr" :label="n" :key="m">{{ n }}</el-radio>
                        </el-radio-group>
                    </span>
                </div>
            </div>
            <div class="footerR">
                <img class="img" :src="require('@/assets/png/erweima1.png')" alt="">
                <img class="img" :src="require('@/assets/png/erwema2.png')" alt="">
            </div>
        </footer>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="innerVisible = false">再想想</el-button>
            <el-button size="small" type="primary" @click="send">发送</el-button>
        </span>
    </el-dialog>
</template>

<script>
import hotelDetail from './directSendChild/hotelDetail.vue'
import siteDetail from './directSendChild/siteDetail.vue'
export default {
    props: {
        state: {
            type: Number,
            default: 0
        }
    },
    components: {
        hotelDetail,
        siteDetail
    },
    data() {
        return {
            input: '',
            radio: '',
            innerVisible: false,
            radioSelectList: {
                0: {
                    title: '若这家酒店满房或价格一般',
                    arr: ['需要推荐同预算的其他酒店', '必须这家']
                },
                1: {
                    title: '若这家会议资源已无档期或价格一般',
                    arr: ['需要推荐同预算、同类型其他资源方', '不能换，会议/活动必须在这个资源方这里办']
                }
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        init() {
            this.innerVisible = true
        },
        //发送
        send() {

        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__body {
    padding: 0;
}

/deep/ .el-dialog__header {
    padding-top: 0;
}

/deep/ .innerDialog {
    border: 3px solid #DB4E1A;
    padding: 0.1rem 0.2rem 0.2rem 0.2rem;
}

.title {
    color: #000;
    font-size: 0.15rem;
    margin-bottom: 0.3rem
}

.main {
    margin-bottom: 0.2rem;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 0.14rem;
    margin-bottom: 0.2rem;

    .footerL {
        flex: 1;
        margin-right: 0.2rem;

        .footerLLine {
            display: flex;
            margin-bottom: 0.05rem;
        }
    }

    .footerR {
        display: flex;
        align-items: center;
        flex-direction: column;

        .img {
            width: 0.8rem;
            height: 0.8rem;
            margin-bottom: 0.1rem;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }
        }

    }
}
</style>